import {
  NOT,
  YES
} from './Boolean.lib';
import {
  Obj
} from './Object.lib';
import {
  trim
} from './String.lib';

export function join(input = [], div = ', ') {
  return Arr(
    input
  ).map(
    (v) => trim(v)
  ).filter(
    (v) => !!(v)
  ).join(
    div
  );
}

/**
 * 
 * @param {any} variable 
 * @returns {any[]}
 */
export function getArray(variable) {
  return Array.isArray(variable) ? variable : [];
}
export const Arr = getArray;

export function rearrangeElement(array, currentIndex, newIndex) {
  const _normalizeIndex = (value) => {
    const min = 0;
    const max = array.length - 1;
    value = parseInt(value);
    if ((min >= 0) && (max >= 0) && (min <= max)) {
      if (value > max) { value = max; }
      if (value < min) { value = min; }
    }
    return parseInt(value);
  }
  currentIndex = _normalizeIndex(currentIndex);
  newIndex = _normalizeIndex(newIndex);
  const element = array.splice(currentIndex, 1)[0];
  array.splice(newIndex, 0, element);
  return array;
}


/**
 * Sanitizes an array by removing duplicates and null/undefined values.
 * @param {any[]} arr
 * @returns {any[]}
 */
export function sanitizeArr(arr) {
  return [...new Set(Arr(arr).filter((v) => !!(v)))];
}

export function filterACL(arr) {
  return [
    ...new Set(
      Arr(arr).filter(
        (option) => {
          const { acl } = Obj(option);
          return (!!option && ((acl === undefined) || (acl === true)))
        }
      )
    )
  ];
}

export function ArrInt(arr) {
  return Arr(arr).map((tagId) => parseInt(tagId));
}

/**
 * Adds all elements in the 'itemsToAdd' array to the 'targetList' array, by removing existing duplicates first.
 * @param {any[]} targetList the array to add elements to
 * @param {any[]} itemsToAdd the array of elements to add
 * @returns {any[]} the array with elements added
 */
export function addElements(targetList, itemsToAdd) {
  return [...removeElements(itemsToAdd, targetList), ...targetList];
}

/**
 * Removes all elements in the 'targetList' array from the 'itemToRemove' array.
 * @param {any[]} targetList the array to remove elements from
 * @param {any[]} itemToRemove the array of elements to remove
 * @returns {any[]} the array with elements removed
 */
export function removeElements(targetList, itemToRemove) {
  return [...targetList].filter(
    (item) => NOT(
      itemToRemove.some(
        (element) => element.id === item.id
      )
    )
  );
}

/**
 * Checks if all elements in the 'superset' array are present in the 'subset' array.
 * @param {any[]} superset the array to check against
 * @param {any[]} subset the array of elements to check for
 * @returns {boolean} true if all elements are present, false otherwise
 */
export function yesAllElementsIncluded(superset, subset) {
  const source = Arr(superset);
  const target = Arr(subset);
  return YES(source.length) && YES(target.length) && target.every(
    ({ id }) => source.some(
      ({ id: elementId }) => elementId === id
    )
  );
}
